<script setup>
import lost from "@img/illustrations/lost.svg";
import { Head } from "@inertiajs/vue3";
import ActionButton from "@js/components/ActionButton.vue";
import { useRoute } from "@js/utils/route";
import { useI18n } from "vue-i18n";

const { status } = defineProps({
  status: {
    type: Number,
    required: true,
  },
});

const { t } = useI18n();

const { route } = useRoute();
</script>

<template>
  <Head>
    <title v-if="status === 403">{{ t("title.error403") }}</title>
    <title v-else-if="status === 404">{{ t("title.error404") }}</title>
    <title v-else-if="status === 500">{{ t("title.error500") }}</title>
    <title v-else-if="status === 503">{{ t("title.error503") }}</title>
    <title v-else>{{ t("title.error") }}</title>
  </Head>

  <div
    class="min-w-screen relative flex min-h-screen items-center overflow-hidden bg-blue-100 p-5 lg:p-20"
  >
    <div
      class="relative min-h-full min-w-full flex-1 items-center rounded-3xl bg-white p-10 text-left text-gray-800 shadow-xl md:flex lg:p-20"
    >
      <div class="w-full md:w-1/2">
        <div class="mb-10 lg:mb-20">
          <img src="/images/logo/logo.svg" class="w-1/2" alt="..." />
        </div>

        <div class="mb-10 font-light text-gray-600 md:mb-20">
          <h1
            class="mb-10 text-3xl font-black uppercase text-indigo-600 lg:text-5xl"
          >
            <template v-if="status === 403">
              {{ t("title.error403") }}
            </template>
            <template v-else-if="status === 404">
              {{ t("title.error404") }}
            </template>
            <template v-else-if="status === 500">
              {{ t("title.error500") }}
            </template>
            <template v-else-if="status === 503">
              {{ t("title.error503") }}
            </template>
            <template>
              {{ t("title.error") }}
            </template>
          </h1>

          <p v-if="status === 403">
            {{ t("text.error403") }}
          </p>
          <p v-else-if="status === 404">
            {{ t("text.error404") }}
          </p>
          <p v-else-if="status === 500">
            {{ t("text.error500") }}
          </p>
          <p v-else-if="status === 503">
            {{ t("text.error503") }}
          </p>
          <p v-else>
            {{ t("text.error") }}
          </p>
        </div>

        <div v-if="status !== 503" class="mb-20 md:mb-0">
          <ActionButton :href="route('front.index')">
            {{ t("button.returnToIndex") }}
          </ActionButton>
        </div>
      </div>

      <div class="w-full text-center md:w-1/2">
        <img :src="lost" :alt="t('title.lost')" />
      </div>
    </div>

    <div
      class="pointer-events-none absolute -top-64 right-20 h-96 w-64 -rotate-45 transform rounded-full bg-blue-200 bg-opacity-30 md:-top-96 md:right-32 md:h-full md:w-96"
    ></div>

    <div
      class="pointer-events-none absolute -bottom-96 right-64 h-full w-96 -rotate-45 transform rounded-full bg-indigo-950 bg-opacity-20"
    ></div>
  </div>
</template>
